export default "__VITE_ASSET__CyiPFNdX__"